<template>
	<div class="app_content">
		<el-page-header @back="goBack" content=""></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>名称：</span>
					<span class="glay"
						>{{ appInfo.appName }}({{ appInfo.appTypeName }})</span
					>
				</div>

				<div class="pub-line">
					<span>应用ID：</span>
					<span class="glay">{{ appInfo.appid }}</span>
				</div>

				<div style="margin-top: 30px">
					<el-button
						size="mini"
						@click="handleClick('add')"
						type="success"
						style="margin-bottom: 5px"
						plain
						>新增
					</el-button>
					<div class="public-table-data">
						<el-table
							ref="multipleTable"
							size="medium"
							:data="tableData"
							border
							style="width: 100%"
							row-key="menuId"
							v-loading="loading"
							element-loading-text="等待接口数据返回中······"
						>
							<el-table-column
								type="index"
								label="序号"
								width="80"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="name"
								label="名称"
								align="center"
								width="200"
							>
							</el-table-column>
							<el-table-column
								prop="period"
								label="标识"
								width="150"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="code"
								label="vip 级别"
								width="150"
								align="center"
							>
								<template slot-scope="scope">
									{{ scope.row.code | vipLevel }}
								</template>
							</el-table-column>
							<el-table-column
								prop="unitAmount"
								label="每月价格（$）"
								width="150"
								align="center"
							>
								<template slot-scope="scope">
									{{ formatMoney(scope.row.unitAmount/100) }}
								</template>
							</el-table-column>
							<el-table-column
								prop="firstAmount"
								label="首月价格（$）"
								width="150"
								align="center"
							>
								<template slot-scope="scope">
									{{ formatMoney(scope.row.firstAmount/100) }}
								</template>
							</el-table-column>

							<el-table-column
								label="操作"
								align="center"
								fixed="right"
								min-width="200"
							>
								<template slot-scope="scope">
									<el-button
										size="mini"
										@click="handleClick('edit', scope.row)"
										type="success"
										plain
										>编辑
									</el-button>
									<el-button
										size="mini"
										@click="handleClick('exam', scope.row)"
										type="warning"
										plain
										>资源关联
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!--事件绑定-->
		<el-dialog
			title="编辑/新增"
			:visible.sync="dialogVoucherVisible"
			:close-on-click-modal="false"
			width="800px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="voucherRuleForm"
					:rules="voucherRules"
					:model="voucherParams"
					label-width="120px"
				>
					<el-form-item label="名称：" prop="name">
						<el-input
							clearable
							placeholder="请填写名称"
							v-model="voucherParams.name"
						></el-input>
					</el-form-item>

					<el-form-item label="vip 级别：" prop="code">
						<el-select
							v-model="voucherParams.code"
							clearable
							placeholder="请选择"
							style="width: 100%"
						>
							<el-option
								v-for="(item, index) in codeDict"
								:key="`${index}`"
								:label="`${item.label}`"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('vip')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item label="每月价格($)：" prop="unitAmount">
						<el-input-number
							:precision="2"
							clearable
							:min="0"
							placeholder="请填写每月价格"
							v-model="voucherParams.unitAmount"
						></el-input-number>
					</el-form-item>
					<el-form-item label="首月价格($)：" prop="firstAmount">
						<el-input-number
							:precision="2"
							clearable
							:min="0"
							placeholder="请填写首月价格"
							v-model="voucherParams.firstAmount"
						></el-input-number>
					</el-form-item>

					<el-form-item label="国际化内容：" prop="description">
						<el-input
							type="textarea"
							:autosize="{ minRows: 16, maxRows: 20 }"
							placeholder="请填写内容"
							v-model="voucherParams.description"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVoucherVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleVoucherEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 相关题目 -->
		<el-dialog
			width="600px"
			title="关联题目"
			:visible.sync="innerVisible"
			append-to-body
			:close-on-click-modal="false"
		>
			<el-table
				:data="merchantList"
				border
				style="width: 100%"
				class="rightTable"
			>
				<el-table-column prop="examId" label="题库标识"></el-table-column>
				<el-table-column prop="examInfoId" label="题库code"></el-table-column>
				<el-table-column prop="code" label="操作" min-width="140">
					<template slot-scope="scope">
						<el-button type="warning" size="mini" @click="delRight(scope.row)">
							关联资源
						</el-button>
						<el-button
							type="default"
							size="mini"
							@click="resourceAndFreeRight(scope.row)"
						>
							资源关联免费题库
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="innerVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog
			width="30%"
			title="选择关联资源权益"
			:visible.sync="resourceVisible"
			append-to-body
			:close-on-click-modal="false"
		>
			<el-form label-width="80px">
				<el-form-item class="item" label="资源列表">
					<el-select
						v-model="innerChecked.resourceIds"
						multiple
						placeholder="请选择"
					>
						<el-option
							v-for="item in allResource"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resourceVisible = false">取 消</el-button>
				<el-button type="primary" @click="handelInnerRight">确定</el-button>
			</div>
		</el-dialog>
		<!-- 相关资源-->
		<el-dialog
			width="600px"
			title="资源关联题库"
			:visible.sync="resourceAndFreeVisible"
			append-to-body
			:close-on-click-modal="false"
		>
			<el-table
				:data="resourceList"
				border
				style="width: 100%"
				class="rightTable"
			>
				<el-table-column prop="resourceName" label="资源名称"></el-table-column>
				<el-table-column prop="resourceId" label="资源 id"></el-table-column>
				<el-table-column prop="code" label="操作" min-width="140">
					<template slot-scope="scope">
						<el-button type="default" size="mini" @click="freeRight(scope.row)">
							关联免费测评题库
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resourceAndFreeVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog
			width="30%"
			title="选择关联免费测评题库"
			:visible.sync="freeVisible"
			append-to-body
			:close-on-click-modal="false"
		>
			<el-form label-width="80px">
				<el-form-item class="item" label="题库列表">
					<el-select
						v-model="freeChecked.appExamIds"
						multiple
						placeholder="请选择"
					>
						<el-option
							v-for="item in allResource"
							:key="item.appExamId"
							:label="item.name"
							:value="item.appExamId"
						>
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="freeVisible = false">取 消</el-button>
				<el-button type="primary" @click="handelFreeRight">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { formatMoney } from "@utils/filters/filter";
export default {
	data() {
		return {
			appInfo: {},
			dialogVoucherVisible: false,
			innerVisible: false,
			resourceVisible: false,
			freeVisible: false,
			resourceList: [],
			resourceAndFreeVisible: false,
			voucherParams: {
				currency: "USD",
				period: 1,
				periodUnit: "MONTH",
				unitAmount: "", //每月价格
				firstAmount: "", //首月价格
				description: "", //描述内容
				code: "",
			},
			voucherRules: {
				code: [
					{
						required: true,
						message: "请选择vip 级别",
						trigger: "change",
					},
				],
				unitAmount: [
					{
						required: true,
						message: "请填写每月价格",
						trigger: "blur",
					},
				],
				firstAmount: [
					{
						required: true,
						message: "请填写首月价格",
						trigger: "blur",
					},
				],
			},
			codeDict: [
				{
					label: "等级 1",
					value: "LEVEL1",
				},
				{
					label: "等级 2",
					value: "LEVEL2",
				},
				{
					label: "等级 3",
					value: "LEVEL3",
				},
			],
			languageList: [],
			languageCode: "",
			loading: false,
			tableData: [],
			merchantList: [],
			allResource: [],
			innerChecked: { resourceIds: [] }, //以及选择的权益
			freeChecked: { appExamIds: [] }, //以及选择的权益
			formatMoney,
		};
	},
	filters: {
		vipLevel(value) {
			switch (value) {
				case "LEVEL1":
					return "等级 1";
				case "LEVEL2":
					return "等级 2";
				case "LEVEL3":
					return "等级 3";
			}
		},
	},
	created() {
		this.appInfo = this.$route.query;
		this.getLanguageList();
		this.queryTableData();
	},
	methods: {
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		async queryTableData() {
			const { data: res } = await this.$get(
				`/merchant/price/list/${this.appInfo.appid}`
			);
			this.tableData = res.data;
		},
		goBack() {
			this.$router.go(-1);
		},
		async changeVip() {
			const { data: res } = await this.$get(
				`/merchant/price/${this.voucherParams.id}`,
				{
					headers: {
						"Language-Code": this.languageCode,
					},
				}
			);

			if (res.data != undefined) {
				if (res.data.description) {
					res.data.description = JSON.parse(res.data.description, null, "\t");
				}
				this.voucherParams = res.data;
			}
		},
		async handleClick(type, row = {}) {
			switch (type) {
				case "add":
					this.voucherParams = {
						currency: "USD",
						period: 1,
						periodUnit: "MONTH",
						unitAmount: "", //每月价格
						firstAmount: "", //首月价格
						description: "", //描述内容
						code: "",
					};
					this.dialogVoucherVisible = true;
					break;
				case "edit":
					this.voucherParams = JSON.parse(JSON.stringify(row));
					if (this.voucherParams.description) {
						this.voucherParams.description = JSON.parse(
							this.voucherParams.description
						);
					}
					if (this.voucherParams.unitAmount) {
						this.voucherParams.unitAmount = this.voucherParams.unitAmount / 100;
					}
					if (this.voucherParams.firstAmount) {
						this.voucherParams.firstAmount = this.voucherParams.firstAmount / 100;
					}
					this.dialogVoucherVisible = true;
					break;
				case "exam":
					this.voucherParams = JSON.parse(JSON.stringify(row));
					this.merchant();
					this.innerVisible = true;
					break;
			}
		},
		handleTabClick(e) {
			if (e == "vip" && this.voucherParams.id) {
				return this.changeVip();
			}
		},
		handleVoucherEdit() {
			this.$refs.voucherRuleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认提交, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					const api = this.voucherParams.id
						? "/merchant/price/update"
						: "/merchant/price/create";

					

					const data = JSON.parse(JSON.stringify(this.voucherParams));
					if (data.unitAmount) {
						data.unitAmount = data.unitAmount * 100;
					}
					if (data.firstAmount) {
						data.firstAmount = data.firstAmount * 100;
					}

					data.description = JSON.stringify(data.description);
					data.systemProductId = this.appInfo.appid;
					await this.$post(api, data, {
						headers: {
							isLoading: true,
							"Language-Code": this.languageCode,
						},
					});
					this.queryTableData();
					this.$message.success("操作成功!");
				});
			});
		},
		// 获取创建的appExam的examId集合
		async merchant() {
			const { data: res } = await this.$get(
				`/merchant/price/app/exam/${this.voucherParams.id}`
			);

			if (res.data != undefined) {
				this.merchantList = res.data;
			}
		},
		async delRight(row) {
			const { data: res } = await this.$get(
				`/merchant/price/resource/${this.voucherParams.id}/${row.examInfoId}`
			);

			if (res.data != undefined) {
				this.innerChecked.examInfoId = row.examInfoId;

				this.innerChecked.resourceIds = res.data.reduce((acc, cur) => {
					if (cur.checked) {
						acc.push(cur.id);
					}
					return acc;
				}, []);
				this.allResource = res.data;
				this.resourceVisible = true;
			}
		},
		async resourceAndFreeRight(row) {
			const { data: res } = await this.$get(
				`/merchant/price/resource/list/${this.voucherParams.id}/${row.examInfoId}`
			);

			if (res.data != undefined) {
				this.resourceList = res.data;
				this.resourceAndFreeVisible = true;
			}
		},
		async freeRight(row) {
			const { data: res } = await this.$get(
				`/merchant/price/exam/free/${this.voucherParams.id}/${row.examInfoId}/${row.id}`
			);

			if (res.data != undefined) {
				this.freeChecked.examInfoId = row.examInfoId;
				this.freeChecked.priceResourceId = row.id;

				this.freeChecked.appExamIds = res.data.reduce((acc, cur) => {
					if (cur.checked) {
						acc.push(cur.appExamId);
					}
					return acc;
				}, []);
				this.allResource = res.data;
				this.freeVisible = true;
			}
		},
		handelInnerRight() {
			this.$confirm("确认提交, 是否继续?", "提示", {
				type: "info",
			}).then(async () => {
				const data = {
					priceId: this.voucherParams.id,
					...this.innerChecked,
				};
				await this.$post("/merchant/price/resource/save", data);
				this.$message.success("操作成功!");
				this.resourceVisible = false;
				this.innerChecked = { resourceIds: [] };
			});
		},
		handelFreeRight() {
			this.$confirm("确认提交绑定, 是否继续?", "提示", {
				type: "info",
			}).then(async () => {
				const data = {
					priceId: this.voucherParams.id,
					...this.freeChecked,
				};
				await this.$post("/merchant/price/exam/free/save", data);
				this.$message.success("操作成功!");
				this.freeVisible = false;
				this.freeChecked = { appExamIds: [] };
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.clear_icon_items {
	color: #f56c6c;
	position: absolute;
	left: 14px;
	top: 14px;
}

.clear_icon_items {
	color: #f56c6c;
	position: absolute;
}

.postsdasinfo {
	top: 12px;
	left: 13px;
}

.postsdas {
	top: 12px;
	left: 28px;
}

.appraisal-title {
	color: #3a3a3a;
}

.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.pub-marr {
	margin-top: 20px;
}

.marr {
	margin-top: 30px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.subject {
	color: #8492a6;
	margin-left: 10px;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}

.active-bg1 {
	background: #fbc4c4;
	color: #fff;
}

.diplay {
	display: inline-block;
}

.screenshot {
	display: inline-block;
	vertical-align: text-top;
}

.video-label {
	margin-right: 15px;
}

.item-add {
	margin: 15px 0;

	.el-button {
		margin-bottom: 15px;
	}

	.el-button img {
		max-height: 12px;
	}
}

.style-outer {
	background: #fff;
	float: left;
	margin: 0 20px 20px 0;
	width: 108px;
	height: 110px;
	border: 1px solid #ddd;
	cursor: pointer;
	position: relative;

	.style__font {
		line-height: 5px;
		margin: 0 0 0 10px;
	}

	.isCheck {
		position: absolute;
		top: 0;
		right: 5px;
		z-index: 2;

		.el-icon-success {
			font-size: 20px;
			color: #ddd;
		}
	}
}

.in_tabs {
	padding: 5px 15px;
	border: 1px solid #b3d8ff;
	margin-right: 5px;
	color: #409eff;
	border-radius: 5px;
	box-sizing: border-box;
	cursor: pointer;
}

.in_tabs:hover {
	background: #b3d8ff;
	color: #ffffff;
}

.active_in_tab {
	background: #b3d8ff;
	color: #ffffff;
}

.in_tabs_car {
	padding: 5px 15px;
	border: 1px solid #fbc4c4;
	margin-right: 5px;
	color: #f56c6c;
	border-radius: 5px;
	box-sizing: border-box;
	cursor: pointer;
}

.in_tabs_car:hover {
	border-color: #fbc4c4;
	background: #fbc4c4;
	color: #ffffff;
}

.active_in_tab_car {
	background: #fbc4c4;
	color: #ffffff;
}

.payment_box_infos {
	display: flex;
	align-items: center;
	margin-bottom: 20px;

	.button_item {
		margin-right: 30px;
	}

	.apili_jkds {
		display: flex;
		align-items: center;
		margin-right: 0px;

		span {
			display: block;
			white-space: nowrap;
			margin-left: 60px;
		}
	}
}

.app_info_name {
	font-size: 14px;
	font-weight: bold;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}
</style>

<style>
.autos .el-tabs__nav-wrap {
	width: 270px !important;
}

.autos .el-tabs__nav {
	width: 100% !important;
}

.autos .el-tabs__item {
	width: 50%;
	padding: 0 !important;
	text-align: center;
	font-weight: 600;
}

.autos .el-tabs__active-bar {
	height: 1px !important;
}

.autos .el-tabs__nav-wrap::after {
	height: 1px !important;
}
</style>
